export const STORAGE_KEYS = {
  theme: 'zgs.theme',
  sidebarCollapsed: 'zgs.sidebar.collapsed',
  authToken: 'zgs.auth.token',
  authRefresh: 'zgs.auth.refresh',
  authUser: 'zgs.auth.user',
} as const;

export const THEME = {
  light: 'light',
  dark: 'dark',
  system: 'system',
} as const;

export const HTTP_STATUS = {
  ok: 200,
  created: 201,
  noContent: 204,
  badRequest: 400,
  unauthorized: 401,
  forbidden: 403,
  notFound: 404,
  serverError: 500,
} as const;

